export const optimizeMenuDeprecatedRouteMap = {
  "/customers/:customerId/flexsave-aws": "/customers/:customerId/optimize/flexsave-compute",
  "/customers/:customerId/flexsave-kubernetes": "/customers/:customerId/optimize/perfectscale",

  "/customers/:customerId/insights": "/customers/:customerId/optimize/insights",

  "/customers/:customerId/insights/new-insight/:insightKey?":
    "/customers/:customerId/optimize/insights/new-insight/:insightKey?",

  "/customers/:customerId/insights/:providerId/:insightKey":
    "/customers/:customerId/optimize/insights/:providerId/:insightKey",

  "/customers/:customerId/spot-scaling": "/customers/:customerId/optimize/spot-scaling",
  "/customers/:customerId/spot-scaling/:asgName": "/customers/:customerId/optimize/spot-scaling/:asgName",
};
